// 巡检记录
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  PictureOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined
} from '@ant-design/icons';
import { theme, Card, Tag, Table, App, Pagination, Spin } from 'antd';
import { getPatrolImages } from '@/server/risk'
import { basicPath } from '@/router/config';//引入路由基础路径

function Record (props) {
  const { getInfo } = props
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const location = useLocation();//接受传值数据
  const navigate = useNavigate();//路由跳转
  const token = localStorage.getItem('dock_token');
  const {
    token: { colorText, colorPrimary },
  } = theme.useToken(); //获取主题颜色
  const [searchList, setSearchList] = useState({
    access_token: token,
    title: '',
    status: '',
    type: '',
    order: '',
    page: 1,
    perpage: 10,
  });//搜索的数据
  const [dataList, setDataList] = useState([])//获取到的数据
  const [total, setTotal] = useState(0);//总条数
  const [currentType, setCurrentType] = useState({})//当前选择的种类 

  useEffect(() => {
    setLoading(true)
    let obj = { ...searchList };
    let list = {
      type: 0,
      typeName: '',
    }
    // 常规巡检记录
    if (location.pathname === '/record_routine') {
      obj.type = 1
      list = {
        type: 1,
        typeName: 'record_routine',
      }
    }
    // 高危巡检记录
    if (location.pathname === '/record_leak') {
      obj.type = 2
      list = {
        type: 2,
        typeName: 'record_leak',
      }
    }
    // 定点巡检记录
    if (location.pathname === '/record_accurate') {
      obj.type = 4
      list = {
        type: 4,
        typeName: 'record_accurate',
      }
    } // 指令飞行记录
    if (location.pathname === '/record_command_flight') {
      obj.type = 1
      list = {
        type: 1,
        typeName: 'record_command_flight',
      }
    }
    setCurrentType(list)
    setSearchList({ ...obj })
    getRecords(obj)
    //eslint-disable-next-line
  }, [location.pathname])

  // 获取记录
  const getRecords = async (obj) => {
    setLoading(true)
    let res = await getPatrolImages(obj)
    if (res.ret === 200) {
      setTotal(res.data.total)
      setDataList(res.data.items)
    } else {
      message.warning(res.msg || `服务器开了小差，请重试`);
    }
    setLoading(false)
  }
  //图片查看页
  const PictureViewPage = (item) => {
    console.log('点击图片：', item);
    const transfer = {
      statid: item.id || item.statid,
      insIds: Number(item.InsIDs),
      routeName: item.routes_name,
      startTime: item.start_time,
      endTime: item.endtime,
    }
    const obj = {
      showMain: false,
      transfer: transfer,
      type: searchList.type,
      typeName: currentType.typeName
    }
    getInfo(obj)
  }


  //表头配置
  const columns = [
    {
      title: '类型',
      dataIndex: 'executetype',
      render: (text, record) => {
        return (
          <div>
            {text === 1 ? `常规` : text === 2 ? `临时` : `暂无类型`}
          </div>
        )
      }
    },
    { title: '航线名称', dataIndex: 'routes_name', },
    { title: '总里程(km)', dataIndex: 'routes_len', },
    {
      title: '巡检起止',
      render: (text, record) => {
        return (
          <div style={{ textAlign: 'left' }}>
            <div>
              {record.start_time.split(' ')[0]} <span className='opa45'> {record.start_time?.split(' ')[1]} </span>
            </div>
            <div style={{ display: record.endtime ? 'none' : '', color: (record.endtime) ? colorText : 'var(--error-color)' }}> ~ </div>
            <div style={{ display: record.endtime ? '' : 'none' }}>
              {record.endtime?.split(' ')[0]} <span className='opa45'> {record.endtime?.split(' ')[1]} </span>
            </div>
          </div>
        )
      },
    },
    {
      title: '图像',
      dataIndex: 'pic_count',
      render: (text, record) => {
        return (
          text
            ?
            <div className='flex pointer'
              onClick={() => { PictureViewPage(record) }}
            >
              <span className='pdR8' style={{ color: '#177DDC' }} >{text}</span>
              <PictureOutlined style={{ color: '#177DDC' }} />
            </div>
            : <span className='opa25'>-</span>
        )
      },
    },
    {
      title: '状态',
      dataIndex: 'ins_status',
      render: (text, record) => {
        return (
          <div className='flex'>
            <div>
              <Tag style={{ display: text === 2 ? `block` : `none` }}
                icon={<SyncOutlined spin />} color="processing">
                执行中
              </Tag>
            </div>
            <div>
              <Tag style={{ display: text === 1 || text === 3 ? `block` : `none` }}
                icon={<CheckCircleOutlined />} color="success">
                完成
              </Tag>
            </div>
            <div>
              <Tag style={{ display: text === 5 ? `block` : `none` }}
                icon={<CloseCircleOutlined />} color="error">
                失败
              </Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: '说明',
      render: (_, item, index) => {
        return (
          <div>
            {item.remark ? <span>{item.remark}</span> : <span className='opa25'>-</span>}
          </div>
        )
      },
    },
  ];

  return (
    <Card className="mar24" bodyStyle={{ padding: '24px' }}>
      <Table
        columns={columns}
        dataSource={dataList}
        pagination={false}
        loading={loading}
        rowKey='id'
      // onChange={(pagination, filters, sorter) => {
      //   console.log(pagination, filters, sorter);
      // }}
      >
      </Table>
      <div className='pdT16'>
        <Pagination align='end' current={searchList.page} pageSize={searchList.perpage} total={total} showTotal={total => `共 ${total} 条数据`}
          onChange={
            (current, pageSize) => { //选择当前页后执行
              let obj = { ...searchList };
              obj.perpage = pageSize;
              obj.page = current;
              setSearchList({ ...obj });
              getRecords(obj);
            }
          } />
      </div>
    </Card>
  )
}
export default Record